import React from 'react';
import { AiOutlineSend } from 'react-icons/ai';
import './style.scoped.scss';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const Input = ({
  message,
  handleQuery,
  handleOnChange,
  inputDisabled,
  user,
}) => {
  return user.remainingQueries <= 0 && user.remainingAdditionalQueries <= 0 ? (
    <OverlayTrigger
      placement='top'
      overlay={
        <Tooltip id='button-tooltip'>
          You have consumed all AI Queries Credits
        </Tooltip>
      }
    >
      <div className='queryInput'>
        <textarea
          className='queryInput__input'
          id='query'
          placeholder='Enter your Query here'
          disabled={true}
          style={{ cursor: 'not-allowed' }}
        />
        <button
          className='sendBtn'
          disabled={true}
          style={{
            cursor: 'not-allowed',
          }}
        >
          <AiOutlineSend />
        </button>
      </div>
    </OverlayTrigger>
  ) : (
    <div className='queryInput'>
      <textarea
        className='queryInput__input'
        id='query'
        onChange={(e) => handleOnChange(e.target.value)}
        value={message}
        placeholder='Enter your Query here'
        required
        disabled={inputDisabled}
        onKeyDown={
          message === '' || message.trim() === ''
            ? null
            : (e) => {
                if (e.key === 'Enter') {
                  handleQuery(e);
                }
              }
        }
        style={{
          cursor: 'text',
        }}
      />
      <button
        className='sendBtn'
        onClick={(e) => handleQuery(e)}
        disabled={message === '' || message.trim() === '' || inputDisabled}
        style={{
          cursor: 'pointer',
        }}
      >
        <AiOutlineSend />
      </button>
    </div>
  );
};

export default Input;
